import { render, staticRenderFns } from "./RemoteIslandType.vue?vue&type=template&id=05edef0f&scoped=true&"
import script from "./RemoteIslandType.vue?vue&type=script&lang=js&"
export * from "./RemoteIslandType.vue?vue&type=script&lang=js&"
import style0 from "./RemoteIslandType.vue?vue&type=style&index=0&id=05edef0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05edef0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05edef0f')) {
      api.createRecord('05edef0f', component.options)
    } else {
      api.reload('05edef0f', component.options)
    }
    module.hot.accept("./RemoteIslandType.vue?vue&type=template&id=05edef0f&scoped=true&", function () {
      api.rerender('05edef0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/form/select/RemoteIslandType.vue"
export default component.exports